
const getProfileRoomType = (roomType, sendienceLength, bgColorCd) => {
    let returnValue;
    if (roomType === RoomType.PROJECT) {
        returnValue = 'project-chat color-code-' + Often.null2Void(bgColorCd, "0");
    } else if (roomType === RoomType.MULTI) {
        returnValue = sendienceLength > 4 ? 'type4' : 'type' + sendienceLength;
    } else {
        returnValue = 'type1';
    }
    return returnValue;
}

const chatListSetting = (lastChatTime) => {
    return Time.isYesterday(lastChatTime) ? i18next.t(dictionary.yesterday) : Time.format(lastChatTime, Time.isToday(lastChatTime) ? "type8" : 'type2');
}

const changeContents = (chatData, isOrigin, isLongText) => {

    const isChangeRoomName = Often.null2Void(chatData.DEL_GB, '') === 'T';
    let applyCntn = chatData.CNTN;
    const applyMsgGb = chatData.MSG_GB;
    const applyBombYn = chatData.BOMB_YN
    const applyRgsnNm = Often.null2Void(chatData.RGSR_NM, chatData.SEND_USER_NM);
    const applyVcSrno = Often.null2Void(chatData.VC_SRNO, "0");
    const isLong = "Y" === Often.null2Void(chatData.LONG_YN, "N") || isLongText;
    const roomSrno = chatData.CHATTING_ROOM_SRNO ? chatData.CHATTING_ROOM_SRNO + "-widget" : chatData.ROOM_SRNO + "-widget";

    applyCntn = (applyCntn === "()" ? "" : applyCntn);

    if (isOrigin) {
        if (applyMsgGb === 'X') return i18next.t('front.alert.deletedMessage');
        else return TagConvert.db2HtmlStringByChat(applyCntn, isLong);
    }

    let returnText = "";
    if (applyBombYn === "Y") returnText = i18next.t('front.common.chatSecret');
    else if (applyMsgGb === "I" || applyMsgGb === "G") returnText = i18next.t(dictionary.image)
    else if (applyMsgGb === "F") returnText = i18next.t(dictionary.attachment)
    else if (applyMsgGb === "S") returnText = i18next.t(main.voiceMessage);
    else if (applyMsgGb === "E" && applyCntn === "") returnText = i18next.t(dictionary.emoji);
    else if (applyMsgGb === 'R' && applyCntn === "") returnText = i18next.t(dictionary.emoji);
    else if (applyMsgGb === "T") returnText = i18next.t('front.common.chatbot');
    else if ("0" !== applyVcSrno) returnText = i18next.t('front.common.userVideoConference', {user: applyRgsnNm});

    if ("" !== returnText) {
        returnText = ListHelper.replaceJson("({contents})", {contents: returnText});
        return returnText;
    }
    if (isChangeRoomName) returnText = getContents("C", {SEND_NAME: applyRgsnNm, ROOM_SRNO: roomSrno});
    else if (applyMsgGb === "X") return i18next.t('front.alert.deletedMessage');
    else returnText = TagConvert.db2TwoStringByChatting(applyCntn);

    if (applyMsgGb === "R" && "" === returnText && chatData.EMOTI_PATH !== '') returnText = "(" + i18next.t('dictionary.emoji') + ")";

    return returnText;

    function getContents(msgGb, dataJson) {
        return MessengerJsonMaker.makeSpecialMsgRecJson(msgGb, '', dataJson).CNTN;
    }
}


function escapeHtml(input) {
    return input
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
}

/*채팅 아이템 리스트 dom으로 변환하여 반환하는 함수*/
const getChattingItemsObj = (chattingArray) => {
    return chattingArray.map((chatting) => {
        return getChatItem(chatting)
    }).join('');
}

const getChatItem = (chatting) => {

    let {
        ROOM_GB = "",
        MSG_GB = "",
        RGSN_DTTM = "",
        BG_COLOR_CD = "",
        ROOM_SRNO = "",
        BOMB_YN = "",
        PIN_YN = "N",
        PUSH_ALAM_YN = "Y",
        NOT_READ_CNT = "0",
        ROOM_NM,
        SENDIENCE_PHTG = "",
        SENDIENCE_CNT = "0",
        CNTN,
    } = chatting

    ROOM_SRNO = ROOM_SRNO + "-widget";
    const memberCount = Number(SENDIENCE_CNT) === 1 ? 1 : Number(SENDIENCE_CNT) - 1;
    ROOM_NM = escapeHtml(ROOM_NM)
    return `<li id="chatting-${ROOM_SRNO}" class="js-chatting-item" data-room-srno="${ROOM_SRNO}" data-bg-color-cd="${BG_COLOR_CD}" pin-yn="${PIN_YN}">
                    <div class="mini-mode-text-sub-area-1">
                        <div class="mini-mode-main-picture-1 mini-mode-chattng-type profile ${getProfileRoomType(ROOM_GB, memberCount, BG_COLOR_CD)}">
                            ${ListHelper.setProfileImg(ROOM_GB, SENDIENCE_PHTG)}
                        </div>
                        <div class="mini-mode-area-list-type-1">
                            <p>
                                <strong class="js-title">${ROOM_NM}</strong>
                                <span class="mini-mode-chattng-type-2" ${ListHelper.setDisplay(Number(SENDIENCE_CNT) > 2 || ROOM_GB === "2")}="">(${SENDIENCE_CNT})</span>
                                <i class="no-alarm mini-mode-chattng-icon-type-1" ${ListHelper.setDisplay("N" === PUSH_ALAM_YN, 'inline-block')}=""></i>
                                <i class="pin mini-mode-chattng-icon-type-2" ${ListHelper.setDisplay("Y" === PIN_YN, 'inline-block')}=""></i>
                            </p>
                            <p class="mini-mode-text-gray-1">
                                <i ${ListHelper.setDisplay(BOMB_YN !== 'Y' && (MSG_GB === 'I' || MSG_GB === 'G'), 'inline-block')}="" class="js-image-icon all-setup-icon-type-2"></i>
                                <i ${ListHelper.setDisplay(BOMB_YN !== 'Y' && MSG_GB === 'F', 'inline-block')}="" class="js-file-icon all-setup-icon-type-1"></i>
                                <span><a class="js-cntn">${Mutil.tag2html(CNTN)}</a></span>
                            </p>
                        </div>
                        <div class="mini-mode-chattng-type-3">
                            <div class="mini-mode-chattng-type-text-1 not-read-count" ${ListHelper.setDisplay(Number(NOT_READ_CNT) > 0, 'inline-block')}="">${NOT_READ_CNT}</div>
                            <div class="mini-mode-chattng-type-text-2 js-date">${chatListSetting(RGSN_DTTM)}</div>
                        </div>
                    </div>
                </li>`
}


const updateDataOnChattingItem = ($chattingItem, chatData) => {
    const applyRgsnDttm = chatData.RGSN_DTTM;
    const isFile = chatData.MSG_GB === "F";
    const isImage = chatData.MSG_GB === "I" || chatData.MSG_GB === "G";
    const contents = changeContents(chatData);

    $chattingItem.find(".js-image-icon").css("display", isImage ? "inline-block" : "none");
    $chattingItem.find(".js-file-icon").css("display", isFile ? "inline-block" : "none");
    $chattingItem.find(".js-cntn").text(contents);
    $chattingItem.find(".js-date").text(chatListSetting(applyRgsnDttm));
}

/*채팅방의 안읽은 채팅 갯수 업데이트 함수*/
const updateBadgeOnChattingItem = ($chattingItem, count) => {
    ListHelper.setCount($chattingItem.find(".not-read-count"), count);
}



export {
    updateBadgeOnChattingItem,
    getChattingItemsObj,
    getProfileRoomType,
    chatListSetting,
    changeContents,
}
